module.exports = __webpack_public_path__ + "static/media/Vela - DK Gold.f407f601.jpg";